import React from 'react';
import { connect } from 'react-redux';
import { selectPrice, selectRatePeriodDays, selectTitle } from "../store";
import { TariffTitle } from "../../TariffTitle";
var _ConvergentTariffTitle = function _ConvergentTariffTitle(_ref) {
  var title = _ref.title,
    price = _ref.price,
    periodDays = _ref.periodDays;
  return /*#__PURE__*/React.createElement(TariffTitle, {
    isComposePeriodDay: true,
    periodDays: periodDays,
    price: price,
    title: title,
    "data-t-id": "ConvergentTariff-ConvergentTariffTitle"
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    title: selectTitle(state),
    price: selectPrice(state),
    periodDays: selectRatePeriodDays(state)
  };
};
export var ConvergentTariffTitle = connect(mapStateToProps)(_ConvergentTariffTitle);